<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Dashboard</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row align-items-center">
            <div class="mr-3" style="min-width: 200px;">
              <a-select
                size="large"
                style="width: 100%"
                placeholder="All Sessions"
                optionFilterProp="children"
                v-model="selectedSession"
                :filterOption="false"
                :defaultValue="undefined"
                @change="handleSessionSelect"
              >
                <template v-for="session in schoolSessions">
                  <a-select-option :value="session.id" :key="session.id">
                    {{session.name}} <small class="text-primary ml-1" v-if="session.is_current">Current</small>
                  </a-select-option>
                </template>
              </a-select>
            </div>
            <div>
              <a-button type="primary" size="large" @click="showCarryForwardModal" style="background-color: #28a745; border-color: #28a745;">
                <i class="fe fe-arrow-right-circle mr-2"></i>Carry Forward
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <carry-forward-modal
      :visible="carryForwardVisible"
      :sessions="schoolSessions"
      :currentSession="selectedSession"
      @close="carryForwardVisible = false"
      @success="handleCarryForwardSuccess"
    />

    <div class="card">
      <div class="card-body">
          <div class="mb-4">
            <h5 class="card-title">Stock Level of Products in Inventory</h5>
            <p class="lead font-size-14 card-subtitle">This data is calculated based on minimum stock level and maximum stock level defined by you.</p>
          </div>

          <div class="d-flex flex-row flex-wrap justify-content-between">

              <div class="card" style="background-color: #ffebee; width: 18rem;">
                  <div class="card-body">
                    <a @click="outofstock">
                      <dashboard-card
                        title="Out of Stock"
                        description="Total products"
                        :count=data.oos
                      />
                    </a>
                </div>
              </div>

              <div class="card" style="background-color: #fff9c4; width: 18rem;">
                <div class="card-body">
                  <a @click="reorderedstock">
                    <dashboard-card
                      title="Re-Order Stock"
                      description="Total products"
                      :count=data.reorder_stock
                    />
                  </a>
                </div>
              </div>

              <div class="card"  style="background-color: #c8e6c9; width: 18rem;">
                <div class="card-body">
                  <a @click="optimumstock">
                    <dashboard-card
                      title="Optimum Stock"
                      description="Total products"
                      :count=data.opt_stock
                    />
                  </a>
                </div>
              </div>

              <div class="card" style="background-color: #ffcdd2; width: 18rem;">
                <div class="card-body">
                  <a @click="highstock">
                    <dashboard-card
                      title="High Stock"
                      description="Total products"
                      :count=data.high_stock
                    />
                  </a>
                </div>
              </div>

          </div>

        <div>
          <div class="card" style="background-color: #90caf9;">
            <div class="card-body">
              <p class="lead text-dark">Total Inventory Products: {{data.total_products}}</p>
            </div>
          </div>
        </div>

        <div>
        </div>

        <div>
          <h5 class="px-4">Inventory Products List</h5>
          <stock-level-table
            v-if="outOfStockState"
            :data="products"
            :laoding="loading"
            @updateTable="outofstock"
          />

          <stock-level-table
            v-if="reOrderedState"
            :data="products"
            :laoding="loading"
            @updateTable="reorderedstock"
          />
          <stock-level-table
            v-if="optimumStockState"
            :data="products"
            :laoding="loading"
            @updateTable="optimumstock"
          />
          <stock-level-table
            v-if="highStockState"
            :data="products"
            :laoding="loading"
            @updateTable="highstock"
          />
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import DashboardCard from '@/components/inventory/dashboard/index'
import StockLevelTable from '@/components/inventory/dashboard/StockLevelTable'
import CarryForwardModal from '@/components/inventory/dashboard/CarryForwardModal'
import { find } from 'lodash'

export default {
  // name: 'Inventory Dashboard',
  components: {
    DashboardCard,
    StockLevelTable,
    CarryForwardModal,
  },
  mounted: function() {
    this.getSessions()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      products: [],
      meta: {},
      current: 1,
      pageSize: 10,
      outOfStockState: true,
      reOrderedState: false,
      optimumStockState: false,
      highStockState: false,
      schoolSessions: [],
      selectedSession: undefined,
      carryForwardVisible: false,
    }
  },
  methods: {
    getSessions: function() {
      this.$http.get('/api/session')
        .then(({ data }) => {
          this.schoolSessions = data.data
          this.selectedSession = find(data.data, ['is_current', 1]).id
          this.getInitData()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInitData() {
      console.log('Dashboard Initial')
      this.clearStockStats()
      this.$http.get('/api/inventory/dashboard', {
        params: {
          session_id: this.selectedSession,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    clearStockStats() {
      this.outOfStockState = false
      this.reOrderedState = false
      this.optimumStockState = false
      this.highStockState = false
    },
    outofstock() {
      this.clearStockStats()
      this.outOfStockState = !this.outOfStockState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=OOS', {
        params: {
          session_id: this.selectedSession,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
    reorderedstock() {
      this.clearStockStats()
      this.reOrderedState = !this.reOrderedState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=ROS', {
        params: {
          session_id: this.selectedSession,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
    optimumstock() {
      this.clearStockStats()
      this.optimumStockState = !this.optimumStockState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=OPTS', {
        params: {
          session_id: this.selectedSession,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
    highstock() {
      this.clearStockStats()
      this.highStockState = !this.highStockState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=HS', {
        params: {
          session_id: this.selectedSession,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
    handleSessionSelect(selectedSession) {
      this.getInitData()
    },
    showCarryForwardModal() {
      this.carryForwardVisible = true
    },
    handleCarryForwardSuccess() {
      this.carryForwardVisible = false
      this.getInitData()
      this.$neoNotify.success('Inventory carried forward successfully.')
    },
  },
}
</script>
